/**
 * BalanceCard — the Home wallet: the three internal currencies side by side
 * (Frame 1 «Главная»).
 *
 * Pure presentation over a server-provided {@link UserBalance}; the client never
 * derives or mutates balances (ledger lives on the server).
 */
import { CurrencyIcon, type CurrencyKind } from "@melusine/shared-ui";
import {
  balanceOf,
  CURRENCY_META,
  type CurrencyKind as BalanceCurrencyKind,
  type UserBalance,
} from "@entities/currency";
import { formatUnits } from "@shared/lib/format";

import styles from "./BalanceCard.module.css";

/** Map the balance currency kind to the shared-ui {@link CurrencyIcon} kind. */
const ICON_KIND: Readonly<Record<BalanceCurrencyKind, CurrencyKind>> = {
  mora: "mora",
  primogems: "primogem",
  star_glitter: "glitter",
};

export interface BalanceCardProps {
  readonly balance: UserBalance;
}

export function BalanceCard({ balance }: BalanceCardProps): JSX.Element {
  return (
    <div className={styles.grid}>
      {CURRENCY_META.map((meta) => (
        <div key={meta.kind} className={styles.cell}>
          <CurrencyIcon kind={ICON_KIND[meta.kind]} size={34} />
          <span className={styles.label}>{meta.label}</span>
          <span className={styles.amount}>
            {formatUnits(balanceOf(balance, meta.kind))}
          </span>
        </div>
      ))}
    </div>
  );
}
